import '../shared/sectores';
import '../../assets/css/horizontal-scroller.scss';
import './solution-preview.scss';
import './solution-preview.component';
import { getText, appendText } from '../../assets/js/text-renderer';
import { LANGUAGE } from '../../constants';

const headerImages = {
  retail: 'cabecera-retail',
  hospitality: 'cabecera-horeca',
  insurance: 'cabecera-seguros',
  industry: 'cabecera-industria',
  admin: 'cabecera-administracion',
  strategy: 'servicios/expert-guidance/cabecera-strategy',
  'business-intelligence': 'servicios/business-intelligence/cabecera-bi',
  'machine-learning': 'servicios/artificial-intelligence/cabecera-ml',
  infrastructure: 'servicios/data-architecture/cabecera-infrastructure',
};
const headerImagesMobile = {
  retail: 'cabecera-retail',
  hospitality: 'cabecera-horeca',
  insurance: 'cabecera-seguros',
  industry: 'cabecera-industria',
  admin: 'cabecera-administracion',
  strategy: 'servicios/expert-guidance/movil/cabecera-strategy-m',
  'business-intelligence': 'servicios/business-intelligence/movil/cabecera-bi-m',
  'machine-learning': 'servicios/artificial-intelligence/movil/cabecera-ml-m',
  infrastructure: 'servicios/data-architecture/movil/cabecera-infrastructure-m',
};

const groupURIs = {
  default: 'solutions&filter_query[component][in]=solution',
  industry: 'solutions/industry/',
  retail: 'solutions/retail/',
  hospitality: 'solutions/hospitality/',
  insurance: 'solutions/insurance/',
  admin: 'solutions/admin/',
  strategy: 'solutions&with_tag=strategy',
  'business-intelligence': 'solutions&with_tag=bi',
  'machine-learning': 'solutions&with_tag=ml',
  infrastructure: 'solutions&with_tag=infrastructure',
};

const introURIs = {
  default: '',
  industry: 'industry',
  retail: 'retail',
  hospitality: 'hospitality',
  insurance: 'insurance',
  admin: 'admin',
  strategy: 'strategy',
  'business-intelligence': 'bi',
  'machine-learning': 'ml',
  infrastructure: 'infrastructure',
};

const sectores = ['industry', 'retail', 'hospitality', 'insurance', 'admin'];
const tipologias = ['strategy', 'machine-learning', 'business-intelligence', 'infrastructure'];

const solutionGroup =
  [...sectores, ...tipologias].reduce((acc, val) => {
    if (window.location.pathname.indexOf(val) > 0) return val;
    return acc;
  }, null) || 'solutions';

console.log(solutionGroup, groupURIs[solutionGroup]);

const uri = solutionGroup !== 'solutions' ? groupURIs[solutionGroup] : groupURIs.default;
const header = document.getElementById('header-image').children[0].children;

const pretitle = document.getElementById('summary-pretitle');
if (sectores.includes(solutionGroup)) pretitle.innerText = LANGUAGE === 'en' ? 'Industry' : 'Sector';
else if (tipologias.includes(solutionGroup)) pretitle.innerText = LANGUAGE === 'en' ? 'Type' : 'Tipologia';
else pretitle.innerText = LANGUAGE === 'en' ? 'Solutions' : 'Soluciones';

// if (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text) {
//   window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
//   window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
//   window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'cta' }));
//   // document.dispatchEvent(new Event('render-ready'));
// } else {
//   loadIntro(group || tag);
//   loadGroup(uri);
//   loadHeaderPic();
// }

document.addEventListener('DOMContentLoaded', function () {
  if (DEVELOPMENT || (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text)) {
    loadText();
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
      window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
      window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'cta' }));
    }, 5000);
  }
});

function loadText() {
  loadIntro(solutionGroup);
  loadGroup(uri);
  loadHeaderPic();
}

function loadHeaderPic() {
  if (sectores.includes(solutionGroup)) {
    header[0].setAttribute('srcset', `/assets/img/usecases/solutions/cabecera/${headerImages[solutionGroup]}.webp`);
    header[1].setAttribute(
      'srcset',
      `/assets/img/usecases/solutions/cabecera/movil/${headerImages[solutionGroup]}-m.webp`
    );
    header[1].setAttribute('alt', `${headerImages[solutionGroup].split('-')[1]}`);
  } else if (tipologias.includes(solutionGroup)) {
    header[0].setAttribute('srcset', `/assets/img/${headerImages[solutionGroup]}.webp`);
    header[1].setAttribute('srcset', `/assets/img/${headerImagesMobile[solutionGroup]}.webp`);
    header[1].setAttribute('alt', `${headerImages[solutionGroup]}`);
  } else {
    header[0].setAttribute('srcset', `/assets/img/servicios/expert-guidance/cabecera-strategy.webp`);
    header[1].setAttribute('srcset', `/assets/img/servicios/expert-guidance/movil/cabecera-strategy-m.webp`);
    header[1].setAttribute('alt', `expert-guidance`);
  }
}

async function loadIntro(page) {
  if (!page || page === 'solutions') appendText('Todas nuestras soluciones', 'summary-title');
  else {
    await getText(`solutions/intros/${introURIs[page]}`).then((dict) => {
      const intro = dict.stories[0] || null;
      if (intro) {
        appendText(intro.content.title, 'summary-title');
        appendText(intro.content.description, 'summary-description');
      }
    });
  }
}

async function loadGroup(uri) {
  await getText(uri).then((dict) => {
    // console.log('uri', uri);
    // console.log('dict', dict);
    
    const blocks = dict.stories;
    if (blocks) {
      const solutionsElement = document.getElementById('solutions-component');
      solutionsElement.setAttribute('content', JSON.stringify(blocks));
    }
  });
}
